const TRANSFERABLE_STATUS = new Set(['online']);

export function chosenAvailability(agent) {
  return String(agent?.availability || '').toLowerCase();
}

function statusRank(status) {
  return String(status || '').toLowerCase() === 'online' ? 0 : 1;
}

export function filterTransferTargets(agents, currentUserId) {
  const meId = Number(currentUserId);
  if (!Array.isArray(agents)) return [];
  return agents
    .filter(a => {
      if (!a?.sip_extension || !String(a.sip_extension).trim()) return false;
      if (Number.isFinite(meId) && Number(a.id) === meId) return false;
      return TRANSFERABLE_STATUS.has(chosenAvailability(a));
    })
    .sort((a, b) => {
      const byStatus = statusRank(chosenAvailability(a)) - statusRank(chosenAvailability(b));
      if (byStatus !== 0) return byStatus;
      return String(a.available_name || a.name || '').localeCompare(
        String(b.available_name || b.name || '')
      );
    });
}

export function inboundAutoRejectStatusCode(availability) {
  const s = String(availability || '').toLowerCase();
  if (s === 'busy' || s === 'offline') return 486;
  return null;
}

/**
 * Parse REFER NOTIFY sipfrag body for SIP status.
 * @param {string} body
 * @returns {{ statusCode: number|null, provisional: boolean }}
 */
export function parseReferNotifySipfrag(body) {
  const text = (body || '').toString();
  const match = text.match(/SIP\/2\.0\s+(\d{3})/i);
  if (!match) return { statusCode: null, provisional: false };
  const statusCode = Number(match[1]);
  const provisional = statusCode >= 100 && statusCode < 200;
  return { statusCode, provisional };
}

/**
 * Map REFER NOTIFY SIP status to transfer UX cause.
 * @param {number|null} statusCode
 * @returns {'ringing'|'rejected'|'no_answer'|'failed'|null}
 */
export function referNotifyCause(statusCode) {
  const code = Number(statusCode);
  if (!code) return null;
  if (code >= 180 && code < 200) return 'ringing';
  if (code === 486 || code === 603) return 'rejected';
  if (code === 408 || code === 480) return 'no_answer';
  if (code >= 300) return 'failed';
  return null;
}
